<template>
  <v-layout :fill-height="isLoading">
    <MainMenu />
    <PageLoader v-if="isLoading" />
    <v-flex v-else>
      <v-layout
        column
        fill-height
      >
        <listPagesHeader
          :page-title="pageTitle"
          :show-btn="false"
          class="none-growth"
        />
        <v-layout
          class="page-content-paddings"
          wrap
          mb-4
        >
          <v-flex xs12>
            <v-flex
              x12
              class="lh-1 mt-3"
            >
              <a
                class="link_iconed lh-1"
                @click="forward()"
              >
                <v-icon>chevron_left</v-icon>
                {{ $t('warehouses.buttons.back') }}
              </a>
            </v-flex>
            <v-layout :wrap="xsOnly">
              <v-flex
                xs12
                class="mt-4"
              >
                <BaseWarehouseData
                  :warehouse="warehouse"
                  :rejon="leaders.location_name"
                  @reload="fetchWarehouse"
                />
              </v-flex>
            </v-layout>
            <v-flex
              xs12
              class="mt-4"
            >
              <warehouseVolunteersData
                :is-supporting="isSupporting"
                :warehouse-manager="warehouse.warehouse_manager"
                :warehouse-manager-phone="warehouse.warehouse_data.warehouse_manager.phone"
                :leaders-list="leaders.leaders"
              />
            </v-flex>
            <v-flex
              v-if="isSupporting && familiesLoading"
              xs12
              class="mt-4"
            >
              <warehouseFamilyList :warehouse-id="warehouseId" />
            </v-flex>
            <v-flex
              xs12
              class="mt-4"
            >
              <warehouseDetails
                :warehouse="warehouse"
                :resource="resource"
              />
            </v-flex>
            <v-flex
              v-if="false"
              xs12
              class="mt-4 mb-5"
            >
              <v-btn
                block
                color="sz_transparent"
                :class="[{ 'responsive-btn-text': xsOnly }]"
              >
                <v-icon small>
                  clear
                </v-icon>
                {{ $t('warehouses.turn_off') }}
              </v-btn>
            </v-flex>
          </v-flex>
        </v-layout>
        <v-flex class="none-growth footer-wrap">
          <div class="page-content-paddings">
            <AppFooter class="mb-3" />
          </div>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import MainMenu from '@/components/widgets/menu/MainMenu';
import AppFooter from '@/components/widgets/AppFooter';
import listPagesHeader from '@/components/widgets/lists/ListPagesHeader';
import BaseWarehouseData from '@/components/warehouseCard/BaseWarehouseData';
import warehouseVolunteersData from '@/components/warehouseCard/WarehouseVolunteersData';
import warehouseFamilyList from '@/components/warehouseCard/warehouseFamilyList';
import warehouseDetails from '@/components/warehouseCard/warehouseDetails';
import PageLoader from '@/components/widgets/PageLoader';

export default {
    name: 'WarehouseCard',
    components: {
        PageLoader,
        warehouseDetails,
        warehouseFamilyList,
        warehouseVolunteersData,
        BaseWarehouseData,
        MainMenu,
        AppFooter,
        listPagesHeader
    },
    beforeRouteEnter (to, from, next) {
        next((vm) => {
            vm.$store
                .dispatch('warehouse/getWarehouse', {
                    warehouseId: vm.warehouseId,
                    isForm: false
                })
                .then((data) => {
                    vm.resourceLoading = true;
                    if (data.warehouse_type !== 'supporting') {
                        vm.leadersLoading = true;
                        vm.$store
                            .dispatch('defaultApi/getWioStructInfo', data.wio_struct_location_id)
                            .then(() => {
                                vm.leadersLoading = false;
                            });
                        vm.$store.dispatch('warehouses/loadResource', 3).then(() => {
                            vm.resourceLoading = false;
                        });
                    } else {
                        vm.$store.dispatch('warehouses/loadResource', 4).then(() => {
                            vm.resourceLoading = false;
                        });
                        const data = {
                            params: {
                                limit: 20,
                                offset: 0
                            },
                            warehouseId: vm.warehouseId
                        };
                        vm.$store.dispatch('warehouse/getFamiliesPerWarehouse', data).finally(() => {
                            vm.familiesLoading = true;
                        });
                    }
                });
        });
        next();
    },
    beforeRouteLeave (to, from, next) {
        this.$store.commit('defaultApi/setWiosStructInfo', {});
        this.$store.commit('warehouse/setWarehouseVerifyPermissions', null);
        this.$store.commit('warehouse/setWarehouse', null);
        this.$store.commit('warehouses/setWarehouseWasEdited', false);
        this.$store.commit('warehouse/setFamiliesInWarehouse', []);
        this.$store.commit('warehouse/setFamiliesInWarehouseAmount', null);
        next();
    },
    data () {
        return {
            leadersLoading: false,
            resourceLoading: true,
            familiesLoading: false
        };
    },
    computed: {
        isLoading () {
            return this.warehouse == null || this.leadersLoading === true || this.resourceLoading === true;
        },
        xsOnly () {
            return this.$vuetify.breakpoint.xsOnly;
        },
        warehouseId () {
            return parseInt(this.$route.params.id);
        },
        warehouse () {
            return this.$store.getters['warehouse/getWarehouse'];
        },
        isSupporting () {
            return this.warehouse.warehouse_type === 'supporting';
        },
        pageTitle () {
            if (this.isSupporting) {
                return this.warehouse.warehouse_name;
            }
            return 'Magazyn rejonowy: ' + this.leaders.location_name;
        },
        leaders () {
            return this.$store.getters['defaultApi/getWioStructInfo'];
        },
        resource () {
            return this.$store.getters['warehouses/getResource'];
        }
    },
    methods: {
        forward () {
            this.$router.push({ name: 'warehouse-list' });
        },
        fetchWarehouse () {
            this.$store.commit('warehouses/setWarehouseWasEdited', true);
            this.$store.dispatch('defaultApi/getWioStructInfo', this.warehouse.wio_struct_location_id);
            this.$store.dispatch('warehouse/getWarehouse', {
                warehouseId: this.warehouseId,
                isForm: false
            });
        }
    }
};
</script>

<style scoped></style>
